var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12620",
    "data-name": "Group 12620",
    transform: "translate(-297 -126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_614",
    "data-name": "Ellipse 614",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(297 126)",
    fill: "#1ac9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20278",
    "data-name": "Path 20278",
    d: "M-466.35,72.11l-6.767,6.767a1.513,1.513,0,0,1-1.077.446,1.513,1.513,0,0,1-1.077-.446l-3.449-3.449a1.513,1.513,0,0,1-.446-1.077,1.513,1.513,0,0,1,.446-1.077,1.513,1.513,0,0,1,1.077-.446,1.513,1.513,0,0,1,1.077.446l2.371,2.371,5.69-5.69a1.513,1.513,0,0,1,1.077-.446,1.513,1.513,0,0,1,1.077.446A1.525,1.525,0,0,1-466.35,72.11Z",
    transform: "translate(782.322 63.944)",
    fill: "#fff"
  }))));
};

export default __webpack_public_path__ + "static/media/checkUnlocked.0103fc00.svg";
export { SvgComponent as ReactComponent };